'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./Toolbar.css');
require('./Brand.css');
var _Brand = require('../Brand/Brand');
var _Brand2 = _interopRequireDefault(_Brand);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/**
 * Brand item component for the toolbar
 */
var ToolbarItemBrand = function ToolbarItemBrand(_ref) {
  var logo = _ref.logo,
    brandName = _ref.brandName,
    productName = _ref.productName,
    href = _ref.href,
    onClick = _ref.onClick,
    className = _ref.className,
    size = _ref.size,
    other = _objectWithoutProperties(_ref, ['logo', 'brandName', 'productName', 'href', 'onClick', 'className', 'size']);
  var classNames = (0, _classnames2.default)('c-toolbar__item', 'c-toolbar__item--brand', className);
  return _react2.default.createElement('div', _extends({}, other, {
    className: classNames
  }), _react2.default.createElement(_Brand2.default, {
    logo: logo,
    brandName: brandName,
    productName: productName,
    href: href,
    onClick: onClick,
    size: size
  }));
};
ToolbarItemBrand.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Source of the brand logo*/
  logo: _propTypes2.default.string,
  /** The brand name*/
  brandName: _propTypes2.default.string,
  /** The product name*/
  productName: _propTypes2.default.string,
  /** The link */
  href: _propTypes2.default.string,
  /** onClick event function*/
  onClick: _propTypes2.default.func,
  /** size of the branding */
  size: _propTypes2.default.oneOf(['default', 'large'])
} : {};
exports.default = ToolbarItemBrand;